import { api } from 'utils/apis/api';
export const ratingApi = api.injectEndpoints({
    endpoints: (builder) => ({
        readRatingSettings: builder.query({
            query: ({ level, surveyType, parentId, language }) => ({
                version: 2,
                path: 'ratings/settings',
                params: { level, surveyType, parentId, language },
                method: 'GET',
            }),
        }),
        getRatingSettings: builder.query({
            query: ({ ratingSettingsId }) => ({
                version: 2,
                path: `ratings/settings/${ratingSettingsId}`,
                method: 'GET',
            }),
        }),
        deleteRatingSettings: builder.query({
            query: ({ ratingSettingsId }) => ({
                version: 2,
                path: `ratings/settings/${ratingSettingsId}`,
                method: 'DELETE',
            }),
        }),
        createRatingSettings: builder.query({
            query: (arg) => ({
                version: 2,
                path: 'ratings/settings',
                method: 'POST',
                body: arg,
            }),
        }),
        //v3, which is not compatible with v2
        linkRatingSettings: builder.query({
            query: (arg) => ({
                version: 3,
                path: `ratings/settings/links`,
                method: 'POST',
                body: {
                    ratingSettingsId: arg.rating_settings_id,
                    contactPoint: arg.contact_point,
                    contactPointKind: arg.contact_point_kind,
                },
            }),
        }),
        unlinkRatingSettings: builder.query({
            query: (arg) => ({
                version: 3,
                path: `ratings/settings/links`,
                method: 'DELETE',
                body: {
                    ratingSettingsId: arg.rating_settings_id,
                    contactPoint: arg.contact_point,
                    contactPointKind: arg.contact_point_kind,
                },
            }),
        }),
        readRatingSettingsLinks: builder.query({
            query: ({ contactPointKind }) => ({
                version: 3,
                path: 'ratings/settings/links',
                method: 'GET',
                params: {
                    contactPointKind,
                },
            }),
        }),
        updateRatingSettings: builder.query({
            query: (arg) => ({
                version: 2,
                path: `ratings/settings/${arg.id}`,
                method: 'PUT',
                body: arg,
            }),
        }),
    }),
});
